import React, { useState } from 'react';
import styled from 'styled-components';
import { array, func, object } from 'prop-types';
import { withConfig, withData } from 'util/hoc';
import { resolve } from 'library/helpers/path-resolver';
import Query from 'library/util/query';
import { jsonToInputParams } from 'library/util/graph';
import { capitalize, pluralize } from 'library/helpers/text';
import { Button } from 'library/components/button';
import Input from 'library/components/form-components/input';
import { BodyText } from 'library/components/text-elements';
import { Book, Clock } from 'library/icons';
import ShareTypeCircle from './share-type-circle';
import * as StyledOutcomesModal from '../styled-outcomes-modal';

export const StyledBook = styled(Book)``;
export const StyledClock = styled(Clock)`
  width: 24px;
  height: 24px;
  fill: white;
  color: white;
  margin-top: 0.2em;
`;

const OutcomesSummary = ({
  outcomeSummaryData,
  submitAction,
  backAction,
  graph_data,
  configuration,
}) => {
  const [shareType, setShareType] = useState('recommendation');
  const [dueDate, setDueDate] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const handleDueDate = (e) => {
    setDueDate(e.target.value);
  };

  if (!graph_data?.fetch_users?.results) return null;
  const users =
    graph_data?.fetch_users?.results?.map((x) => (
      <StyledOutcomesModal.NameLabel key={x.uuid}>
        {x.first_name} {x.last_name}
      </StyledOutcomesModal.NameLabel>
    )) || [];

  const handleSubmit = () => {
    if (shareType === 'assignment' && !dueDate) {
      return;
    }
    setSubmitting(true);
    submitAction({
      ...outcomeSummaryData,
      recommendation_type: shareType,
      due_date: shareType === 'assignment' ? dueDate : undefined,
    });
  };

  const handleOpenUsers = () => {
    return null;
  };

  const total = graph_data?.fetch_users?.pagination?.total || 0;

  return (
    <>
      <BodyText className="recommendationDescription">
        Assign or recommend{' '}
        {pluralize(
          resolve(configuration, 'environment/journey/goals_name', 'outcome')
        )}{' '}
        to Individuals to make them appear in their journeys.
      </BodyText>
      <StyledOutcomesModal.SummaryWrapper>
        <StyledOutcomesModal.StyledRow>
          <StyledOutcomesModal.StyledColumn>
            Individuals:
          </StyledOutcomesModal.StyledColumn>
          <StyledOutcomesModal.StyledColumn>
            {users}
            {total > 10 && (
              <StyledOutcomesModal.OthersLabel onClick={handleOpenUsers}>
                +{total - 10} {pluralize('other', total - 10)}
              </StyledOutcomesModal.OthersLabel>
            )}
          </StyledOutcomesModal.StyledColumn>
        </StyledOutcomesModal.StyledRow>
        <StyledOutcomesModal.StyledRow>
          <StyledOutcomesModal.StyledColumn>
            {capitalize(
              resolve(
                configuration,
                'environment/journey/goals_name',
                'Outcome'
              )
            )}
            :
          </StyledOutcomesModal.StyledColumn>
          <StyledOutcomesModal.StyledColumn>
            {outcomeSummaryData.outcome_name} (
            {outcomeSummaryData.included_goal_ids.length}{' '}
            {pluralize('goal', outcomeSummaryData.included_goal_ids.length)})
          </StyledOutcomesModal.StyledColumn>
        </StyledOutcomesModal.StyledRow>
        <StyledOutcomesModal.StyledRow>
          <StyledOutcomesModal.StyledColumn>
            Type:
          </StyledOutcomesModal.StyledColumn>
          <StyledOutcomesModal.StyledColumn>
            How would you like to share this{' '}
            {resolve(
              configuration,
              'environment/journey/goals_name',
              'outcome'
            )}{' '}
            ?
          </StyledOutcomesModal.StyledColumn>
        </StyledOutcomesModal.StyledRow>
        <StyledOutcomesModal.StyledRow centerAligned>
          <StyledOutcomesModal.StyledColumn>
            <ShareTypeCircle
              onClick={() => setShareType('recommendation')}
              active={shareType === 'recommendation'}
              title="Recommendation"
              description="no due date"
              icon={<StyledBook className="goalCheck" />}
            />
          </StyledOutcomesModal.StyledColumn>
          <StyledOutcomesModal.StyledColumn>
            <ShareTypeCircle
              onClick={() => setShareType('assignment')}
              active={shareType === 'assignment'}
              title="Assignment"
              description="with a due date"
              icon={<StyledClock className="goalCheck" />}
            />
          </StyledOutcomesModal.StyledColumn>
        </StyledOutcomesModal.StyledRow>
        <hr />
        {shareType === 'assignment' && (
          <StyledOutcomesModal.StyledRow centerAligned>
            <div>
              <Input
                onChange={handleDueDate}
                type="date"
                label="Due date"
                value={dueDate}
              />
            </div>
          </StyledOutcomesModal.StyledRow>
        )}
      </StyledOutcomesModal.SummaryWrapper>
      <StyledOutcomesModal.Footer canSubmit>
        <Button className="cancelButton" onClick={backAction}>
          Back
        </Button>
        <Button
          className="confirmButton"
          disabled={(shareType === 'assignment' && !dueDate) || submitting}
          onClick={handleSubmit}
        >
          Finish
        </Button>
      </StyledOutcomesModal.Footer>
    </>
  );
};

OutcomesSummary.propTypes = {
  uuids: array,
  outcomeSummaryData: object,
  backAction: func,
  submitAction: func,
  graph_data: object,
  configuration: object,
};

OutcomesSummary.query = async (token, { uuids }) =>
  await Query(`
    {
      fetch_users(${jsonToInputParams({
        uuids,
        limit: 10,
        offset: 0,
      })}) {
        results {
          uuid,
          first_name,
          last_name
        }
        pagination {
          limit,
          offset,
          total
          }
        }
    }`);

export default withConfig(withData(OutcomesSummary));
